import moment from "moment"
import React from "react"
import BootstrapTable from "react-bootstrap-table-next"

const TotalHoursSpent = props => {
  const { data } = props

  const dataModify = data?.map(el => ({
    ...el,
    commenceDate: moment(el.commenceDate).format("YYYY-MM-DD"),
    lastWorkedDate: moment(el.lastWorkedDate).format("YYYY-MM-DD")
  }));
  
  const totalHoursColumns = React.useMemo(
    () => [
      {
        text: "Commence Date",
        dataField: "commenceDate",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "15px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          />
        ),
      },
      {
        text: "Worked Date",
        dataField: "lastWorkedDate",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "15px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
      },
      {
        text: "Total Hours",
        dataField: "totalHours",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "15px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
      },
    ],
    [data]
  )

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={dataModify || []}
        columns={totalHoursColumns}
        headerClasses="table-light"
        defaultSortDirection="asc"
        noDataIndication="Sorry, There are no data to display"
      />
    </>
  )
}

export default TotalHoursSpent
